import { helper } from '@ember/component/helper';

export function scale(params: number[]) {
  const [input, scaleBy] = params;
  if (!input || !scaleBy) return 0;
  return input * scaleBy;
}

export default helper(scale);
